module.exports = __webpack_public_path__ + "img/menu-board-mc-donald.5a668ade.jpg";